import { render, staticRenderFns } from "./CbsThread.vue?vue&type=template&id=a467219e&scoped=true"
import script from "./CbsThread.vue?vue&type=script&lang=js"
export * from "./CbsThread.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a467219e",
  null
  
)

export default component.exports